import { createFileRoute } from '@tanstack/react-router'
import { BusinessRulesPage } from '../../components/business-rules/BusinessRulesPage'

export const Route = createFileRoute('/$org/business-rules')({
  component: BusinessRulesPage,
})
